if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickViewInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            if (!productElement) {
              throw new Error('product-info not found in response');
            }

            this.loadMissingStylesheets(responseHTML);
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .catch(() => {
            const productUrl = opener.getAttribute('data-product-url');
            this.modalContent.innerHTML =
              '<div class="quick-view-modal__error">' +
              '<p>' + (window.quickViewStrings?.error || 'Não foi possível carregar o produto.') + '</p>' +
              '<a href="' + productUrl + '" class="link">' + (window.quickViewStrings?.viewProduct || 'View product') + '</a>' +
              '</div>';
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      loadMissingStylesheets(responseHTML) {
        const existingHrefs = new Set(
          Array.from(document.styleSheets, (sheet) => sheet.href).filter(Boolean)
        );
        responseHTML.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
          if (!link.href || existingHrefs.has(link.href)) return;
          const clone = document.createElement('link');
          clone.rel = 'stylesheet';
          clone.href = link.href;
          document.head.appendChild(clone);
          existingHrefs.add(link.href);
        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickview-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
/* CDR 4.0 — impedir redirecionamento e abrir o modal */
if (!window.CDRQuickViewClickHandler) {
  window.CDRQuickViewClickHandler = true;

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.quick-view-trigger');

      if (!button) return;

      /* Impede o link do card de abrir a página do produto */
      event.preventDefault();
      event.stopPropagation();

      const modalOpener = button.closest('modal-opener');

      if (!modalOpener) return;

      const modalSelector = modalOpener.getAttribute('data-modal');
      const modal = document.querySelector(modalSelector);

      if (!modal || typeof modal.show !== 'function') {
        console.error('Quick buy modal not found:', modalSelector);
        return;
      }

      /* Abre o modal com fotos, variantes e informações */
      modal.show(button);
    },
    true
  );
}
/* CDR 4.0 — mostra o Select Options no card visível no mobile */
if (!window.CDRQuickViewMobileFocus) {
  window.CDRQuickViewMobileFocus = (() => {
    const mobileQuery = window.matchMedia(
      '(hover: none), (pointer: coarse)'
    );

    let observer;

    function createObserver() {
      if (observer) {
        observer.disconnect();
      }

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const cardIsVisible =
              entry.isIntersecting &&
              entry.intersectionRatio >= 0.68;

            entry.target.classList.toggle(
              'is-quick-view-visible',
              cardIsVisible
            );
          });
        },
        {
          threshold: [0, 0.5, 0.68, 1],
          rootMargin: '-8% 0px -8% 0px'
        }
      );
    }

    function observeCards(container = document) {
      if (!mobileQuery.matches) {
        document
          .querySelectorAll('.is-quick-view-visible')
          .forEach((card) => {
            card.classList.remove('is-quick-view-visible');
          });

        return;
      }

      if (!observer) {
        createObserver();
      }

      container
        .querySelectorAll(
          '.product-card-wrapper:not([data-quick-view-observed])'
        )
        .forEach((card) => {
          card.setAttribute('data-quick-view-observed', 'true');
          observer.observe(card);
        });
    }

    function initialize() {
      observeCards(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      observeCards(event.target);
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', () => {
        createObserver();
        observeCards(document);
      });
    }

    return {
      initialize
    };
  })();
}